import React from 'react'
import { Row, Col, InputNumber, InputGroup } from 'rsuite'
import NumberFormat from 'react-number-format'
import classNames from 'classnames'
import { requiredFiled, isValidators } from '../../../utils/ValidatorUtils'
import ErrorMessage from '../../message/errorMessage/ErrorMessage'

export default function InputNumberForm({
  schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
  ...props
}) {
  const keyName = props.name || schema?.name
  const labelMdLg = props.labelMdLg || 24
  const inputMdlg = props.inputMdlg || 24
  const preWidth = props.preWidth || ''
  const postWidth = props.postWidth || ''
  const inputWidth = props.inputWidth || ''
  const disabled = props.disabled || schema?.disabled
  // const min = props.min || 0
  const max = props.max || 'Infinity'
  const decimalScale = props.decimalScale || undefined

  const value = props.value || schema.value

  return (
    <>
      {schema && (
        <Row style={{ marginTop: 5 }}>
          {errors[keyName] && (
            <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 10 }}>
              <ErrorMessage error={errors[keyName]} />
            </Col>
          )}

          {!props.hideLabel && schema.label && (
            <Col xs={24} sm={24} md={labelMdLg} lg={labelMdLg} style={{ marginTop: 10 }}>
              <p>{requiredFiled(schema.validators, schema.label)}</p>
            </Col>
          )}
          <Col xs={24} sm={24} md={inputMdlg} lg={inputMdlg}>
            <InputGroup>
              {schema.preLabel && (
                <InputGroup.Addon>
                  <p style={preWidth ? { width: preWidth } : {}}>{schema.preLabel}</p>
                </InputGroup.Addon>
              )}
              <Controller
                key={keyName}
                name={keyName}
                control={control}
                rules={isValidators(schema.validators)}
                defaultValue={value}
                render={(props) => {
                  return (
                    <NumberFormat
                      isAllowed={({ floatValue }) =>
                        !floatValue || (max == 'Infinity' ? true : floatValue <= max)
                      }
                      className="rs-input"
                      disabled={disabled}
                      style={inputWidth ? { width: inputWidth } : {}}
                      placeholder={schema.hint || schema.label}
                      thousandSeparator={true}
                      value={props.value}
                      onValueChange={(value) => {
                        setValue(keyName, value.floatValue)
                        clearErrors(keyName)
                      }}
                      decimalScale={decimalScale}
                    />
                  )
                }}
              />
              {schema.postLabel && (
                <InputGroup.Addon>
                  <p style={postWidth ? { width: postWidth } : {}}>{schema.postLabel}</p>
                </InputGroup.Addon>
              )}
            </InputGroup>
          </Col>
        </Row>
      )}
    </>
  )
}
